// types
export type FaqItem = {
  id: string;
  q: string;
  a: string;
  tags?: string[];
};

// contenido
export const FAQS: FaqItem[] = [
  {
    id: "que-es",
    q: "¿Qué es Princonser Kids?",
    a: "Princonser Kids es la primera experiencia inmersiva de formación integral basada en sabiduría. Convierte la sabiduría y el propósito en algo práctico y medible con libros-guía, retos, una plataforma donde se suben evidencias y una App de Debate con gamificación (insignias y títulos). El objetivo: niños sabios en acción, con resultados visibles.",
    tags: ["que es", "programa", "sistema", "producto", "resumen", "sabiduría"]
  },
  {
    id: "edades",
    q: "¿Para qué edades está pensado?",
    a: "Para niños de educación primaria. Trabajamos el rango 6–12 años; la primera fase del programa se centra en 6–11.",
    tags: ["edades", "años", "primaria", "rango", "niños"]
  },
  {
    id: "incluye",
    q: "¿Qué incluye el sistema?",
    a: "Una serie de libros-guía y actividades con retos y ejercicios prácticos; plataforma y dashboard para subir avances; gamificación (insignias/títulos) y App de Debate; además, un currículo integral que aborda salud mental/emocional, social/profesional, física/biológica y financiera.",
    tags: ["incluye", "contenido", "libros", "app", "debate", "insignias", "títulos", "currículo"]
  },
  {
    id: "app-debate",
    q: "¿Cómo funciona la App de Debate?",
    a: "La App de Debate desbloquea experiencias conforme avanzas. El debate se mide por el uso de la sabiduría (no solo por persuadir), con ranking internacional opt-in, y se integra con las insignias/títulos logrados en los retos.",
    tags: ["app", "debate", "ranking", "experiencias", "argumentación", "sabiduría"]
  },
  {
    id: "precio",
    q: "¿Cuánto cuesta?",
    a: "El precio estimado de lanzamiento del sistema completo ronda €300 (puede variar por país, impuestos y promociones). La App de Debate prevé modelos de suscripción.",
    tags: ["precio", "cuesta", "costo", "pago", "suscripción", "promociones"]
  },
  {
    id: "en-casa",
    q: "¿Cómo se integra en casa?",
    a: "Con sesiones cortas, actividades guiadas y retos en familia que reducen conflictos por pantallas, crean hábitos semanales y refuerzan el vínculo. Verás progreso medible (insignias/reportes) y controles de privacidad con datos mínimos y ranking solo si lo habilitas.",
    tags: ["casa", "hogar", "familia", "rutinas", "pantallas", "hábitos", "privacidad"]
  },
  {
    id: "colegios",
    q: "¿Y para colegios?",
    a: "Ofrecemos currículo complementario listo para usar, métricas por aula, participación familiar y soporte. Empezamos con pilotos y luego acuerdos anuales; la implementación es sencilla y con acompañamiento.",
    tags: ["colegio", "escuela", "institución", "tutorías", "métricas", "pilotos", "acuerdos"]
  },
  {
    id: "humano",
    q: "Quiero hablar con un humano",
    a: null as any,
    tags: ["humano", "asesor", "agente", "whatsapp", "soporte", "contacto"]
  }
];

// ejemplo de "botones iniciales" (quick actions)
export const QUICK_BUTTONS = [
  "¿Qué es Princonser Kids?",
  "¿Para qué edades está pensado?",
  "¿Qué incluye el sistema?",
  "¿Cómo funciona la App de Debate?",
  "¿Cuánto cuesta?",
  "¿Cómo se integra en casa?",
  "¿Y para colegios?"
];

